// src/Components/TourPackages/tourPackagesData.js
export const tourPackagesData = {
  "hyderabad-sightseeing-tour-package": {
    slug: "hyderabad-sightseeing-tour-package",
    title: "Hyderabad Sightseeing Tour Package",
    price: "₹3,500",
    duration: "Full Day",
    image: "https://www.planetware.com/wpimages/2020/06/india-goa-best-beaches-colva-beach.jpg",
    description: "Explore Hyderabad’s famous landmarks including Charminar, Golconda Fort, and more.",
    itinerary: [
      "Pickup from hotel",
      "Visit Charminar",
      "Visit Golconda Fort",
      "Lunch at local restaurant",
      "Return to hotel"
    ],
    inclusions: ["Transport", "Lunch", "Tour Guide"],
    exclusions: ["Personal Expenses", "Tips", "Entry Fees"]
  },
  "hyderabad-to-goa-tour-package": {
    slug: "hyderabad-to-goa-tour-package",
    title: "Hyderabad to Goa Tour Package",
    price: "₹12,500",
    duration: "3 Nights / 4 Days",
    image: "https://www.planetware.com/wpimages/2020/06/india-goa-best-beaches-colva-beach.jpg",
    description: "Enjoy a beach vacation in Goa with sightseeing and water activities.",
    itinerary: ["Day 1: Travel to Goa", "Day 2: Beach day", "Day 3: Sightseeing", "Day 4: Return to Hyderabad"],
    inclusions: ["Flights", "Hotel", "Breakfast"],
    exclusions: ["Dinner", "Personal Expenses"]
  },
  "hyderabad-to-hampi-tour-package": {
    slug: "hyderabad-to-hampi-tour-package",
    title: "Hyderabad to Hampi Tour Package",
    price: "₹9,000",
    duration: "2 Nights / 3 Days",
    image: "https://karnatakatourism.org/wp-content/uploads/2020/05/Vastuchitra_Krishna-Bazaar-Pushkarni-Hampi-03-1.jpg",
    description: "Explore the UNESCO World Heritage site Hampi with temples and ruins.",
    itinerary: ["Day 1: Travel to Hampi", "Day 2: Sightseeing Hampi ruins", "Day 3: Return to Hyderabad"],
    inclusions: ["Transport", "Hotel", "Breakfast"],
    exclusions: ["Lunch", "Personal Expenses"]
  },
  "srisailam-temple-tour-package": {
    slug: "srisailam-temple-tour-package",
    title: "Srisailam Temple Tour Package",
    price: "₹6,000",
    duration: "1 Night / 2 Days",
    image: "https://media.assettype.com/outlooktraveller/2024-07/de3b5fc9-0fbf-41f2-ad04-d11a18b85b24/shutterstock_1009388953.jpg?w=1200&h=675&auto=format%2Ccompress&fit=max&enlarge=true",
    description: "Visit the famous Srisailam temple with a comfortable stay nearby.",
    itinerary: ["Day 1: Travel to Srisailam", "Day 2: Temple visit and return"],
    inclusions: ["Transport", "Hotel", "Breakfast"],
    exclusions: ["Lunch", "Personal Expenses"]
  },
  "warangal-heritage-tour-package": {
    slug: "warangal-heritage-tour-package",
    title: "Warangal Heritage Tour Package",
    price: "₹5,500",
    duration: "Full Day",
    image: "https://curlytales.com/wp-content/uploads/2023/06/Warangal-.jpg",
    description: "Explore Warangal's forts, temples, and heritage sites in a day trip.",
    itinerary: ["Pickup from Hyderabad", "Visit Warangal Fort", "Visit Thousand Pillar Temple", "Return to Hyderabad"],
    inclusions: ["Transport", "Tour Guide"],
    exclusions: ["Meals", "Personal Expenses"]
  },
  "hyderabad-to-vijayawada-tour-package": {
    slug: "hyderabad-to-vijayawada-tour-package",
    title: "Hyderabad to Vijayawada Tour Package",
    price: "₹8,000",
    duration: "2 Nights / 3 Days",
    image: "https://dynamic-media-cdn.tripadvisor.com/media/photo-o/0f/b5/db/4f/prakasam-barrage.jpg?w=1400&h=1400&s=1",
    description: "Visit Vijayawada with Krishna river sightseeing and cultural trips.",
    itinerary: ["Day 1: Travel to Vijayawada", "Day 2: Sightseeing", "Day 3: Return to Hyderabad"],
    inclusions: ["Transport", "Hotel", "Breakfast"],
    exclusions: ["Lunch", "Dinner", "Personal Expenses"]
  }
};
